import React from "react";
import { useNavigate } from "react-router-dom";
import { createTeamMember } from "adminApi/TeamListApi/TeamList"; // ← your API endpoint
import { validateForm } from "utils/validation";
import { TeamRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddTeamMemberForm from "./Componates/AddTeamMeberForm";
import fields from "../json/TeamMemberList.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddTeamMember = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize default values
  const initialValues = formdata.reduce(
    (acc, field) => ({ ...acc, [field.name]: "" }),
    {}
  );

  const { values, errors, handleChange, handleFileChange } = useFormChange(
    initialValues,
    TeamRules
  );

  const { loading, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => {
        formData.append(key, val ?? "");
      });
      return await createTeamMember({ data: formData });
    },
    (vals) => validateForm(vals, TeamRules),
    () => navigate(-1),
    "Team member Created successfully"
  );

  return (
    <>
      {loading && <Spinner isSpinner={true} />}
      <AddTeamMemberForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        imagePreview={values.photographPreview || (values.photograph && values.photograph)
        }
        loading={loading}
      />
    </>
  );
};

export default AddTeamMember;
